import { PolicyPageLayout } from '@/components/ui/PolicyPageLayout';
import { usePrivacyText } from '@/hooks/usePrivacyText';

export function PrivacyPolicy() {
  const { privacyText } = usePrivacyText();

  return <PolicyPageLayout title="Privacy Policy" blocks={privacyText} />;
}
